import React from 'react';
import { CTAButton } from './CTAButton';
export const ProductDetails = () => {
  return <section className="w-full bg-gray-50 py-12 px-4" data-id="element-569">
      <div className="max-w-4xl mx-auto" data-id="element-570">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-teal-700 mb-8" data-id="element-571">
          Customer Voices & Product Details
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-572">
          <div className="bg-white p-5 rounded-lg shadow-sm text-center" data-id="element-573">
            <div className="flex justify-center mt-2 text-yellow-400 mb-4" data-id="element-574">
              <span data-id="element-575">★★★★★</span>
            </div>
            <p className="text-gray-600 italic mb-3" data-id="element-576">
              "12‑hour retail shift. Soft, breathable—and I didn't tug it once."
            </p>
            <p className="text-sm text-gray-500" data-id="element-577">— Verified Buyer</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-sm text-center" data-id="element-578">
            <div className="flex justify-center mt-2 text-yellow-400 mb-4" data-id="element-579">
              <span data-id="element-580">★★★★★</span>
            </div>
            <p className="text-gray-600 italic mb-3" data-id="element-581">
              "Stairs used to make me nervous. This feels secure but not tight."
            </p>
            <p className="text-sm text-gray-500" data-id="element-582">— Verified Buyer</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-sm text-center" data-id="element-583">
            <div className="flex justify-center mt-2 text-yellow-400 mb-4" data-id="element-584">
              <span data-id="element-585">★★★★★</span>
            </div>
            <p className="text-gray-600 italic mb-3" data-id="element-586">
              "Replaced two drawer‑sleeves with this and finally stopped fussing
              with it."
            </p>
            <p className="text-sm text-gray-500" data-id="element-587">— Verified Buyer</p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm mb-8" data-id="element-588">
          <h3 className="text-xl font-semibold text-center text-teal-700 mb-6" data-id="element-589">
            Advanced Design Details
          </h3>
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-590">
            <div className="md:w-1/2" data-id="element-591">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aCx64eFzXvFUawJyJRmFcd/upcloseWhicks.jpg" alt="Close-up of Ardava bamboo compression fabric" className="w-full rounded-lg mb-3" data-id="element-592" />
              <p className="text-sm text-center text-gray-600" data-id="element-593">
                Breathable bamboo-blend fabric with 360° gentle compression
              </p>
            </div>
            <div className="md:w-1/2" data-id="element-594">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mj9DveSUzXKY7CyD9hmWf3/image15.jpg" alt="Close-up of Ardava sleeve edge construction" className="w-full rounded-lg mb-3" data-id="element-595" />
              <p className="text-sm text-center text-gray-600" data-id="element-596">
                Flatlock seams and tapered cuff design prevent rolling and
                discomfort
              </p>
            </div>
          </div>
          <div className="mt-8" data-id="element-597">
            <h4 className="font-semibold text-lg mb-4 text-teal-700 text-center" data-id="element-598">
              Stability During Activity
            </h4>
            <div className="max-w-md mx-auto" data-id="element-599">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jhcLSe8U2ZKJMndeDxVEuT/woman_Jogging.webp" alt="Woman jogging with Ardava sleeve" className="w-full rounded-lg mb-3" data-id="element-600" />
            </div>
            <p className="text-gray-600 text-center" data-id="element-601">
              Stability during workouts, if you need a bit more stability when
              running, cycling or during leg day, this support will be good for
              you.
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-602">
          <div className="md:w-1/2" data-id="element-603">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qC9sD7GpxvzSzYTbWtiJpC/packaging.png" alt="Ardava Bamboo Compression Sleeve Packaging" className="w-full rounded-lg" data-id="element-604" />
          </div>
          <div className="md:w-1/2" data-id="element-605">
            <h3 className="text-xl font-semibold mb-4 text-teal-700" data-id="element-606">
              Guarantee (Zero‑Risk Try)
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-607">
              Try Ardava for 60 days. If it rolls, bunches, or isn't the most
              comfortable sleeve you've worn, we'll refund every penny.
            </p>
            <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" style={{
            display: 'block'
          }} data-id="element-608">
              <button className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-2 rounded-md font-medium w-full" data-id="element-609">
                Find Your Size & Get a Pair — 60‑Day Guarantee
              </button>
            </a>
            <p className="text-xs text-gray-500 mt-2" data-id="element-610">
              Price locks at checkout · Free first size exchange
            </p>
          </div>
        </div>
      </div>
    </section>;
};